import axios from 'axios';

const NEXTGEN_ROOT = process.env.VUE_APP_NEXTGEN_API_URI;

const NextGenApiService = {
    getPing() {
        return axios.get(`${NEXTGEN_ROOT}/v1/ping`);
    },
};

export default NextGenApiService;